// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__3QAvO","signatureButtonsRight":"ModalSign_signatureButtonsRight__2Gyhh"};